import { render, staticRenderFns } from "./PayerSummary.vue?vue&type=template&id=d5d87b58&scoped=true&"
import script from "./PayerSummary.vue?vue&type=script&lang=js&"
export * from "./PayerSummary.vue?vue&type=script&lang=js&"
import style0 from "./PayerSummary.vue?vue&type=style&index=0&id=d5d87b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d87b58",
  null
  
)

export default component.exports